import { render, staticRenderFns } from "./ModalGerar.vue?vue&type=template&id=3eb52f24"
import script from "./ModalGerar.vue?vue&type=script&lang=js"
export * from "./ModalGerar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports